import type {ReleasePr} from '../api/releases'
export function ownerDecision(pr:ReleasePr){
 const d=pr.owner_decision
 return d&&d.head_sha===pr.head_sha&&d.task_id===pr.task?.id&&['night','emergency'].includes(d.mode)&&d.approved_by?.toLowerCase()==='nizan@otomator.co.il'&&Number.isFinite(Date.parse(d.approved_at))?d:null
}
export function decisionNextStep(mode:string,state='open'){if(state==='merged')return 'מוזג · אפשר לעקוב אחר אימות הפריסה';if(state==='closed')return 'ה־PR נסגר. לא מתוכנן מיזוג.';return mode==='night'?'ימוזג ב־23:15':'ממזג אחרי שהבדיקות עוברות'}
